import React from 'react'
import Constant from '../../Constant';
function TranCom({ img, header, sub, date }) {
    return (
        <div className=' flex my-6 justify-between items-center gap-2'>
            <div className=' flex gap-3 items-center min-w-0'>
                <div className=' flex-shrink-0'>
                    <img src={img} alt='imgg' className=' w-10 h-10 object-contain' />
                </div>
                <div className=' min-w-0'>
                    <p className=' text-[13px] sm:text-[16px] text-[#1E222B] font-bold truncate'>₦{Constant.FormatNumber(header)}</p>
                    <p className=' text-[12px] sm:text-[14px] text-[#808285] font-normal leading-[150%]'>{sub}</p>
                </div>
            </div>
            <div className=' flex-shrink-0 text-right'>
                <p className=' text-[12px] sm:text-[14px] text-primary-color6 whitespace-nowrap'>{date}</p>
            </div>
        </div>
    )
}

export default TranCom